import React from 'react'

const SearchIcon = (props) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M14.1304 9.60963C14.4925 7.91717 14.016 6.08124 12.7011 4.7663C10.639 2.70423 7.29577 2.70423 5.2337 4.7663C3.17163 6.82837 3.17163 10.1716 5.2337 12.2337C7.29577 14.2958 10.639 14.2958 12.7011 12.2337L15.8374 15.37' stroke='#33354D' strokeLinecap='round' />
    </svg>
  )
}

export default SearchIcon
